/*
 * Copyright (c) 2025. Bolmate B.V.
 */

import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {BolmateSelect} from '../../controls';

import {NotificationInterval} from '../../../util/enums';

import {BolmateSelectItem} from '../../../util/interfaces';

import Notification from '../../../models/notificationModel';

interface Props {
    onChangeNotification: (notification: Notification) => void;
    disabled: boolean;
    notification: Notification;
    withRealtime?: boolean;
}

export default function NotificationIntervalComp(props: Props) {
    const {t} = useTranslation();
    const {onChangeNotification, notification, disabled, withRealtime} = props;
    const selectItems: Array<BolmateSelectItem> = useMemo(() => {
        const items: Array<BolmateSelectItem> = [
            {value: '', label: t('notifications.components.intervalWhen', 'Wanneer'), selectable: false},
            {
                value: NotificationInterval.DAY,
                label: t('notifications.components.intervalDay', 'dag'),
                info: t('notifications.components.intervalDayInfo', 'Gebundeld per dag.')
            },
            {
                value: NotificationInterval.WEEK,
                label: t('notifications.components.intervalWeek', 'week'),
                info: t('notifications.components.intervalWeekInfo', 'Gebundeld per week.')
            },
            {
                value: NotificationInterval.MONTH,
                label: t('notifications.components.intervalMonth', 'maand'),
                info: t('notifications.components.intervalMonthInfo', 'Gebundeld per maand.')
            }
        ];
        if (withRealtime)
            items.splice(1, 0, {
                value: NotificationInterval.INSTANT,
                label: t('notifications.components.intervalInstant', 'direct'),
                info: t('notifications.components.intervalInstantInfo', 'Notificaties worden realtime verzonden.')
            });
        return items;
    }, [withRealtime, t]);

    function onChange(value: NotificationInterval) {
        notification.interval = value;
        onChangeNotification(notification);
    }

    return (
        <section>
            <label className='fixed-text'>{t('notifications.components.intervalPerLabel', 'per')}</label>
            <BolmateSelect
                value={notification.interval}
                onChange={onChange}
                items={selectItems}
                className='select-field'
                disabled={disabled}
            />
        </section>
    );
}
